export const dataFields = {
  CNES: 'nu_cnes',
  INE: 'nu_ine',
  CPF: 'nu_cpf',
  CNS: 'nu_cns',
  CBO: 'co_cbo',
  Função: 'no_cbo',
  Profissional: 'no_profissional',
  Divergência: 'divergencias',
}
